<template>
  <div class="card">
    <el-card v-if="$slots.head" class="card__head op_card_head" shadow="never">
      <template>
        <slot name="head"></slot>
      </template>
    </el-card>
    <el-card v-if="$slots.content" shadow="never" class="card__content">
      <template>
        <slot name="content"></slot>
      </template>
    </el-card>
    <el-card v-if="$slots.foot" shadow="never" class="card__foot">
      <template>
        <slot name="foot"></slot>
      </template>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    height: {},
  },
};
</script>

<style src="./style.scss" lang="scss"></style>



// WEBPACK FOOTER //
// index.vue?17408ca0